import React from 'react';
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import {useNavigate} from "react-router-dom";

const BreadPath = (props) => {
    let  put= props.path
    let navigate = useNavigate();
    return (
        <>
            <Breadcrumbs className={"cursorlink myfont paddingTop15 paddingBot15"} aria-label="breadcrumb">
            {put.map((obj, index) => {
                    return (
                        <Link key={index}
                              className={"cursorlink myfont"}
                            underline="hover"
                            color="#d8d9d9"
                            onClick={() => {
                                navigate(obj.link)
                            }}
                        >
                            {obj.key}
                        </Link>
                    );
                })}

        </Breadcrumbs>
        </>
    );
};

export default BreadPath;